<ng-container *transloco="let t">
    <div infinite-scroll
         [infiniteScrollDistance]="1"
         (scrolled)="scrolled.emit()"
         class="row"
         [class.row-cols-1]="currentLayout === CalendarViewType.LIST"
         [class.row-cols-1]="currentLayout === CalendarViewType.GRID"
         [class.row-cols-sm-2]="currentLayout === CalendarViewType.GRID"
         [class.row-cols-lg-3]="currentLayout === CalendarViewType.GRID">
        @for (item of events; track item.id) {
        <div class="py-10">
            <app-event-grid-item
                    [eventItem]="item"
                    [languages]="languages"
                    (onRightButtonClickCallback)="onRightButtonClickCallback.emit(item)"/>
        </div>
        }
    </div>
</ng-container>
